import React from 'react';
import { useSelector } from 'react-redux';

import SideBar from '~/components/layout/Sidebar';
import Header from '~/components/layout/Header';
import BackPage from '~/components/layout/BackPage';
import PendencyCard from '~/components/pages/Pendencies/PendecyCard';
import Modal from '~/components/pages/Pendencies/Modal'
import Loading from "~/components/layout/Loading";
import { PendencyProvider, usePendency } from '~/hooks/pendency'

import {
  Container,
  Content,
  PendIcon,
  Main,
  Scroll
} from './styled';

 function Component(){
  const { loading, pendencies, numberOfPendingIssues } = usePendency()
  const classificationReducer = useSelector(
    state => state.classificationReducer,
  );

  return (
    <>
      <Container >
         <SideBar
          menuSelected={'Início'}
          hasPendenciOn={classificationReducer.pendenciesOn}
        >
          <Header modeSimple />
          <BackPage page='/portal' />
          <Main >
            <Content>
              <header>
                <PendIcon />
                <h3>Pendências</h3>
              </header>
              {loading
                ? <Loading margin="100% auto" />
                : (
                  <Scroll>
                    {pendencies.map(item => (
                      <PendencyCard key={item.id} pendency={item} />
                    ))}
                  </Scroll>
                )
              }

            </Content>
          </Main>
        </SideBar>
      </Container>
      <Modal />
    </>

  )
}

export default function Pendencies (){
  return(
    <PendencyProvider>
      <Component />
    </PendencyProvider>
  )
}
